(function () {
  'use strict';

  function hasText(v) {
    return typeof v === 'string' && v.trim() !== '';
  }

  function esc(v) {
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Fila de tabla (antes <li>): el markup tiene que coincidir con el que
  // renderiza collino-product-tabs.liquid, porque esto le reescribe el
  // innerHTML al <tbody> cuando cambia la variante.
  function row(label, value) {
    return hasText(value) ? '<tr><th scope="row">' + esc(label) + '</th><td>' + esc(value) + '</td></tr>' : '';
  }

  // Las pestañas se convirtieron en secciones apiladas (2026-07-30): initTabs,
  // activateTab y window.collinoOpenProductTab se borraron. Se verifico antes
  // que ningun otro archivo del theme los consumia (ni el link #ver-descripcion
  // que escuchaba). Los paneles ahora son visibles siempre; lo unico dinamico
  // que queda es el switch por variante de aca abajo.
  function initVariants(root) {
    var data = window.collinoTabsData;
    if (!data || !data.base) return;

    var specList = root.querySelector('[data-collino-spec]');
    var envioList = root.querySelector('[data-collino-envio]');
    var shippingCheckout = root.querySelector('[data-collino-shipping-checkout]');
    var shippingConsult = root.querySelector('[data-collino-shipping-consult]');
    var specEmpty = root.querySelector('[data-collino-spec-empty]');
    var descText = root.querySelector('[data-collino-desc-text]');
    var faqBody = root.querySelector('[data-collino-faq-body]');


    var baseDescHTML = descText ? descText.innerHTML : '';
    var baseFaqHTML = faqBody ? faqBody.innerHTML : '';

    var currentId = null;


    function pick(over, base) {
      return hasText(over) ? over : (base || '');
    }

    function computeSpec(v) {
      var b = data.base.spec;
      var o = (v && v.spec) || {};
      return {
        marca: b.marca,
        sku: pick(o.sku, b.sku),
        diametro: pick(o.diametro, b.diametro),
        terminacion: pick(o.terminacion, b.terminacion),
        color: pick(o.color, b.color),
        instalacion: b.instalacion,
        buloneria: pick(o.buloneria, b.buloneria),
        tipo: pick(o.tipo, b.tipo),
        material: pick(o.material, b.material),
        peso: pick(o.peso, b.peso),
        largo: pick(o.largo, b.largo),
        altura: b.altura,
        ancho: b.ancho,
        garantia: pick(o.garantia, b.garantia),
        contenido: pick(o.contenido, b.contenido),
        inflamable: pick(o.inflamable, b.inflamable),
        emisiones: b.emisiones,
        cod_emisiones: b.cod_emisiones
      };
    }

    function computeEnvio(v) {
      var b = data.base.envio;
      var o = (v && v.envio) || {};
      return {
        bultos: b.bultos,
        productos: b.productos,
        metodo: b.metodo,
        costo: b.costo,
        tiempo: b.tiempo,
        peso_paq: pick(o.peso_paq, b.peso_paq),
        alto: pick(o.alto, b.alto),
        ancho: pick(o.ancho, b.ancho),
        largo: pick(o.largo, b.largo)
      };
    }

    function renderSpec(s) {
      if (!specList) return;
      var h = '';
      h += row('Marca', s.marca);
      h += row('SKU', s.sku);
      h += row('Diámetro', s.diametro);
      h += row('Terminación', s.terminacion);
      h += row('Color', s.color);
      h += row('Instalación', s.instalacion);
      h += row('Bulonería incluida', s.buloneria);
      h += row('Tipo de producto', s.tipo);
      h += row('Material', s.material);
      h += row('Peso', s.peso);
      h += row('Largo', s.largo);
      h += row('Altura', s.altura);
      h += row('Ancho', s.ancho);
      h += row('Garantía', s.garantia);
      h += row('Producto inflamable', s.inflamable);
      h += row('Emisiones', s.emisiones);
      h += row('Código de emisiones', s.cod_emisiones);
      specList.innerHTML = h;
      var specPanel = specList.closest('[data-collino-panel="especificaciones"]');
      if (specPanel) specPanel.hidden = !hasText(h);
      if (specEmpty) specEmpty.hidden = hasText(h);
    }

    function renderEnvio(s) {
      if (!envioList) return;
      var h = '';
      h += row('Cantidad de bultos', s.bultos);
      h += row('Cantidad de productos', s.productos);
      h += row('Método de envío', s.metodo);
      h += row('Costo de envío', s.costo);
      h += row('Tiempo de entrega', s.tiempo);
      h += row('Peso total del paquete', s.peso_paq);
      h += row('Alto de caja', s.alto);
      h += row('Ancho de caja', s.ancho);
      h += row('Largo de caja', s.largo);
      envioList.innerHTML = h;
      var shippingTable = envioList.closest('table');
      if (shippingTable) shippingTable.hidden = !hasText(h);
    }

    function parseFaqAnswers(scope) {
      if (!scope) return;
      var answers = scope.querySelectorAll('.collino-faq-answer[data-faq-json]');
      Array.prototype.forEach.call(answers, function (answerDiv) {
        try {
          var json = JSON.parse(answerDiv.getAttribute('data-faq-json'));
          var respuesta = json.respuesta || json._respuesta;
          if (respuesta && respuesta.children) {
            var html = '';
            respuesta.children.forEach(function (p) {
              if (p.children) {
                html += '<p>';
                p.children.forEach(function (child) {
                  if (child.value) html += esc(child.value);
                });
                html += '</p>';
              }
            });
            answerDiv.innerHTML = html;
          }
        } catch (e) {
          answerDiv.innerHTML = '<p style="color:#999;">Error al cargar la respuesta.</p>';
        }
      });
    }

    function update(variantId) {
      variantId = String(variantId || '');
      if (!variantId || variantId === currentId) return;
      currentId = variantId;

      var v = (data.variants && data.variants[variantId]) || null;

      var spec = computeSpec(v);
      renderSpec(spec);
      renderEnvio(computeEnvio(v));
      var isConsultation = !!(v && v.consultation);
      if (shippingCheckout) shippingCheckout.hidden = isConsultation;
      if (shippingConsult) shippingConsult.hidden = !isConsultation;

      if (descText) {
        descText.innerHTML = (v && hasText(v.descripcion)) ? v.descripcion : baseDescHTML;

        // La descripcion vive dentro de <max-height>, que decide si mostrar el
        // "Ver descripcion completa" midiendo el alto del contenido. Solo recalcula
        // en connectedCallback y en resize (assets/max-height.js), asi que al cambiar
        // de variante hay que avisarle: si no, una descripcion mas larga queda
        // recortada sin boton, o una mas corta se queda con un boton que no hace nada.
        window.dispatchEvent(new Event('resize'));
      }

      if (faqBody) {
        faqBody.innerHTML = (v && hasText(v.faq)) ? v.faq : baseFaqHTML;
        parseFaqAnswers(faqBody);
      }
    }

    function getVariantIdFromDOM() {
      var p = new URLSearchParams(window.location.search).get('variant');
      if (p) return p;
      var checked = document.querySelector('input[name="id"]:checked');
      if (checked && checked.value) return checked.value;
      var field = document.querySelector('[name="id"]');
      if (field && field.value) return field.value;
      return data.initialVariantId || null;
    }

    var refreshTimer = null;
    function scheduleRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () { update(getVariantIdFromDOM()); }, 60);
    }

    update(getVariantIdFromDOM());


    var listenerController = new AbortController();
    var listenerOptions = { capture: true, signal: listenerController.signal };
    document.addEventListener('change', scheduleRefresh, listenerOptions);
    document.addEventListener('input', scheduleRefresh, listenerOptions);

    function handleVariantEvent(e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        update(e.detail.variant.id);
      } else {
        scheduleRefresh();
      }
    }
    ['variant:change', 'variantChange', 'product:variant-change', 'on:variant:change'].forEach(function (evt) {
      document.addEventListener(evt, handleVariantEvent, { signal: listenerController.signal });
    });

    var pollId = setInterval(function () {
      if (document.hidden) return;
      var id = getVariantIdFromDOM();
      if (id && String(id) !== currentId) update(id);
    }, 400);

    var productForm =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('main') ||
      document.body;

    var observer = null;
    if (productForm) {
      observer = new MutationObserver(scheduleRefresh);
      observer.observe(productForm, { subtree: true, childList: true });
    }


    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(root)) {
        clearTimeout(refreshTimer);
        clearInterval(pollId);
        if (observer) observer.disconnect();
        listenerController.abort();
        root.dataset.initialized = 'false';
      }
    }, { signal: listenerController.signal });
  }

  function init() {
    var roots = document.querySelectorAll('[data-collino-tabs]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      initVariants(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
